import { Injectable} from '@angular/core';
import { Observable} from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams  } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { AuthService } from '../components/auth.servicice';

@Injectable({
  providedIn: 'root'
})
export class ICAService {

  private urlResourcesIcaInfo: string = environment.urlResourcesIcaInfo;
  private urlResourcesIcaDiscard: string = environment.urlResourcesIcaDiscard;
  
  constructor(private http: HttpClient, private authService: AuthService) {}

  getPendientesPorPagar(): Observable<any> {
    const user = this.authService.getValueUser();
    const data = {"tipoId":user.tipoId,"nroId":user.nroId, "tipoImpuesto":"2", "opcion":"2"};
    let params = new HttpParams();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        params = params.set(key, (data as any)[key]);
      }
    }
    
    const authHeaders = new HttpHeaders().set('Content-Type', 'application/json')
    const httpOptions = { headers: authHeaders, params: params };
    let url = this.urlResourcesIcaInfo;
    if (environment.production == false && environment.proxyOfinaVirtual != null) {
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual);
    }
    return this.http.post(`${url}`, data, httpOptions);
  }

  getPendientesPorFirmar(): Observable<any> {
    const user = this.authService.getValueUser();
    const data = {"tipoId":user.tipoId,"nroId":user.nroId, "tipoImpuesto":"2", "opcion":"0"};
    let params = new HttpParams();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        params = params.set(key, (data as any)[key]);
      }
    }
    
    const authHeaders = new HttpHeaders().set('Content-Type', 'application/json')
    const httpOptions = { headers: authHeaders, params: params };
    let url = this.urlResourcesIcaInfo;
    if (environment.production == false && environment.proxyOfinaVirtual != null) {
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual);
    }
    return this.http.post(`${url}`, data, httpOptions);
  }

  discardForm(item: any): Observable<any> {
    const data = item;
    
    const authHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8')
    const httpOptions = { headers: authHeaders};
    let url = this.urlResourcesIcaDiscard;
    if (environment.production == false && environment.proxyOfinaVirtual != null) {
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual);
    }
    return this.http.post(`${url}`, data, httpOptions);
  }


  cargarDeclaracion(item: any): Observable<any> {
    const fd = new FormData();
    fd.append("formulario", item);
    const data: FormData = fd;
    const config = this.authService.getValueConfig();
    let url = environment.urlPresentacionTraps;
    
    if (environment.production == false && environment.proxyOfinaVirtual != null) {
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual);
    }
    return this.http.post(`${url}`, data);
  }


  presentarDeclaracion(item: any): Observable<any> {
    const data = item;
    const config = this.authService.getValueConfig();
    let url = config.urlPresentacionTraps+"/declarar";
    if (environment.production == false && environment.proxyOfinaVirtual != null) {
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual);
    }
    return this.http.post(`${url}`, data);
  }


}
